export default __webpack_public_path__ + "static/media/rabbit19.eb14dd2e.gif";